import type { AlertLevel } from '@flymind/shared';
import { ALERT_COLORS } from '@flymind/shared';
import { Badge } from './Badge';
import { useTranslation } from '../../hooks/useTranslation';

interface AlertBadgeProps {
  level: AlertLevel;
  className?: string;
}

const levelToVariant: Record<AlertLevel, 'neutral' | 'good' | 'rare' | 'exceptional'> = {
  none: 'neutral',
  good: 'good',
  rare: 'rare',
  exceptional: 'exceptional',
};

const icons: Record<AlertLevel, string> = {
  none: '',
  good: '\u2193',      // down arrow
  rare: '\u2193\u2193',    // double down arrow
  exceptional: '\u26A1', // lightning
};

export function AlertBadge({ level, className = '' }: AlertBadgeProps) {
  const { t } = useTranslation();

  if (level === 'none') return null;

  const label = t(`alerts.${level}` as 'alerts.good' | 'alerts.rare' | 'alerts.exceptional');
  const color = ALERT_COLORS[level];

  return (
    <Badge variant={levelToVariant[level]} className={`${level === 'exceptional' ? 'animate-pulse' : ''} ${className}`}>
      <span style={{ color }} aria-hidden="true">
        {icons[level]}
      </span>
      {label}
    </Badge>
  );
}
